import { createContext, useContext, type ReactNode } from 'react';
import type { Table } from '@tanstack/react-table';

// TableData is unknown type at the moment
type TableData = unknown;

const TableContext = createContext<Table<TableData> | null>(null);

type TableProviderProps = {
  table: Table<TableData>;
  children: ReactNode;
};

export const TableProvider = ({ table, children }: TableProviderProps) => (
  <TableContext.Provider value={table}>{children}</TableContext.Provider>
);

// 2. Custom Hook to easily use the table context in sub-components
export const useTable = () => {
  const context = useContext(TableContext);

  if (!context) {
    throw new Error('useTableContext must be used within a TableProvider');
  }

  return context;
};
